import { render, staticRenderFns } from "./ListBed.vue?vue&type=template&id=6d5473ba&scoped=true"
import script from "./ListBed.vue?vue&type=script&lang=js"
export * from "./ListBed.vue?vue&type=script&lang=js"
import style0 from "./ListBed.vue?vue&type=style&index=0&id=6d5473ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5473ba",
  null
  
)

export default component.exports